import React, { useContext, useState } from 'react';
import { MdSms } from 'react-icons/md';

import { UserItemContext } from 'src/lib/UserItemContext';
import { LoginContext } from 'src/lib/LoginContext';
import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { TextAlertModal } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/CatalogTextAlerts/TextAlertModal/TextAlertModal';
import {
  ItemActionIcon,
  ActionButtons,
} from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/AuctionItemActions.style';

interface ICatalogTextAlerts {
  item: IAuctionItem;
}

export const CatalogTextAlerts = (props: ICatalogTextAlerts) => {
  const { isLoggedIn } = useContext(LoginContext);
  const { auctionTextAlerts } = useContext(UserItemContext);
  const [alertAdded, setAlertAdded] = useState(false);

  const textAlertModalOverlayState = useOverlayTriggerState({});

  const alertSet
    = auctionTextAlerts.filter((alert) => alert.LotNumber === props.item.LotNumber).length > 0;

  function toggleViewTextAlert() {
    if(!isLoggedIn || alertSet || alertAdded) return;
    textAlertModalOverlayState.open();
  }

  return (
    <>
      <ActionButtons
        title='Sign Up For Text Reminders'
        onClick={toggleViewTextAlert}
      >
        <ItemActionIcon active={alertSet || alertAdded}>
          <MdSms />
        </ItemActionIcon>
            Text Reminder
      </ActionButtons>
      {textAlertModalOverlayState.isOpen && (
        <TextAlertModal
          item={props.item}
          closeModal={() => textAlertModalOverlayState.close()}
          addAlert={() => setAlertAdded(true)}
        />
      )}
    </>
  );
};
